import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/** ブレイクポイント */
const breakpoints = {
    lg: 'lg:flex-nowrap lg:flex-row',
    md: 'md:flex-nowrap md:flex-row',
    none: '',
    xl: 'xl:flex-nowrap xl:flex-row',
};
export const TwoColumnLayout = (props) => {
    const { breakpoint = 'lg', children, className = '', overflowClassName = 'overflow-hidden', } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex justify-center flex-col flex-wrap', 'gap-x-[45px] gap-y-[30px]', 'relative', 'w-full', 'mb-80', overflowClassName, breakpoints[breakpoint], className) }, { children: children })));
};
